import shouldShowMoreDetail from './shouldShowMoreDetail';

const calculateQuestionValid = (answer, answerValid, moreDetailTriggers, detail) =>
    shouldShowMoreDetail(answer, moreDetailTriggers) ? !!(answerValid && detail) : answerValid;

export default calculateQuestionValid;
